exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.error-message {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/asna/front-end/public_html/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/asna/front-end/public_html/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/asna/front-end/public_html/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles